import internal from '../img/Internal_Awards_icon1.png';
import customer from '../img/Customer_Awards_icon1.png';
import industry from '../img/Industry_Awards_icon1.png'

import event from '../img/Event_Planner_icon1.png'
import mobile from '../img/Mobile_App_icon1.png'
import qr from '../img/QR_Code_icon1.png'
import support from '../img/Support_icon1.png'

import judges from '../img/AwM_solut_img.png'

import CTAButton from "../components/CTA";


function NewSolutions() {
    return (
        <div className="slide-down">
            <div className="section section-padd">
                <div className="main-wrapper">
                    <div className="text-center" style={{marginBottom: '5%'}}>
                        <h1>Built for Awards Organizers, <br/> Backed by 15+ Years of Experience</h1>
                        <p className="p-60">Whether you're launching an internal awards programme or managing a global competition, AwardMost is the proffesional platform built by awards experts - for awards experts</p>

                        <CTAButton placeholder="Book free consultations" />

                        <br/><br/>
                        <p className="p-60">We support free, paid, online, hybrid or live events. You choose the model.</p>
                    </div>
                </div>
            </div>

            <div className="section section-padd light-blue">
                <div className="main-wrapper">
                    <h2 className="text-center">Who We Help</h2>

                    <div className="columns">
                        <div className="white-box">
                            <img src={internal} alt='internal' />
                            <p className="sub-heading">Internal Awards</p>
                            <p>HR or comms teams running employee recognition</p>
                        </div>
                        <div className="white-box">
                            <img src={customer} alt='customer' />
                            <p className="sub-heading">Customer Awards</p>
                            <p>Marketing or CX teams rewarding client sucess</p>
                        </div>
                        <div className="white-box">
                            <img src={industry} alt='industry' />
                            <p className="sub-heading">Industry Awards</p>
                            <p>Ideal for national or global awards programmes</p>
                        </div>
                    </div>

                    <p className="p-60 text-center">Not sure what ﬁts? We'll help you scope your ideal setup during a quick consultation.</p>
                </div>
            </div>

            <div className="section section-padd">
                <div className="main-wrapper">
                    <h2 className="text-center">Our Pre-Configured Solutions</h2>

                    <div className="columns">
                        <div className="solution-box light-blue">
                            <p className="sub-heading text-center">Starter Solution</p>
                            <p>Ideal for simple internal or regional awards programmes</p>
                            <ul className="solution-list">
                                <li>1 event, 1 admin</li>
                                <li>Free entries</li>
                                <li>Basic scoring</li>
                            </ul>

                            <div className="text-center">
                                <CTAButton placeholder="Let's talk" />
                            </div>

                        </div>

                        <div className="solution-box light-green solution-shadow">
                            <p className="sub-heading text-center">Professional Solution</p>
                            <p>Ideal for customer, partner or paid-entry awards programmes</p>
                            <ul className="solution-list">
                                <li>Custom forms</li>
                                <li>Branded domain</li>
                                <li>Judge comments</li>
                                <li>Reporting</li>
                            </ul>

                            <div className="text-center">
                                <CTAButton placeholder="Let's talk" />
                            </div>

                        </div>

                        <div className="solution-box light-blue">
                            <p className="sub-heading text-center">Enterprise Solution</p>
                            <p>Ideal for national or global awards programmes</p>
                            <ul className="solution-list">
                                <li>Unlimited events</li>
                                <li>Multilingual</li>
                                <li>Advanced scoring rounds</li>
                            </ul>

                            <div className="text-center">
                                <CTAButton placeholder="Let's talk" />
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div className="section section-padd gray-f9">
                <div className="main-wrapper" style={{margin: '3% auto'}}>
                    <div className="columns" style={{alignItems: 'center'}}>
                        <div className='work-box'>
                            <h2 style={{marginTop: '0px', marginBottom: '10px'}}>How it Works</h2>
                            <div className='columns'>
                                <div className='work-box-number'>
                                    <p>1</p>
                                </div>
                                <div className='work-box-info'>
                                    <p className='sub-heading'>Plan</p>
                                    <p className='margin-0'>your awards with help from our team</p>
                                </div>
                            </div>
                            <div className='columns'>
                                <div className='work-box-number'>
                                        <p>2</p>
                                    </div>
                                    <div className='work-box-info'>
                                        <p className='sub-heading'>Launch</p>
                                        <p className='margin-0'>your programme and invite judges, entrants and guests</p>
                                    </div>
                                </div>
                                <div className='columns'>
                                    <div className='work-box-number last-number'>
                                        <p>3</p>
                                    </div>
                                    <div className='work-box-info'>
                                        <p className='sub-heading'>Deliver</p>
                                        <p className='margin-0'>a great experience and access detailed reports</p>
                                    </div>
                                </div>
                        </div>
                        <div className='work-box'>
                            <img src={judges} alt='' />
                        </div>
                    </div>
                </div>
            </div>


            <div className="section section-padd light-green">
                <div className="main-wrapper">
                    <h2 className="text-center">Awards Ceremony & Conference</h2>

                    <p className="p-60 text-center">From planning to on-site or online execution. <br/> AwardMost doesn’t just help you manage entries and judging - we support you through to the ﬁnal celebration.</p>
                    <br/><br/>
                    <p className="p-60 text-center">Whether you’re organising a gala dinner, a live conference, or a hybrid event, we provide the tools to make it smooth, professional, and stress-free.</p>

                    <p className="included"><b>What's Included:</b></p>

                    <div className="columns ceremony">
                        <div className="included-box">
                            <img src={event} alt='event' />
                            <p className="sub-heading">Event Planner <br/> Tool</p>
                            <p>Build detailed schedules, agendas, and seating plans - all in one central place.</p>
                        </div>
                        <div className="included-box">
                            <img src={mobile} alt='mobile' />
                            <p className="sub-heading">Mobile App for Attendees</p>
                            <p>Use our event companion app to manage registration, real-time check-in, and audience ﬂow.</p>
                        </div>
                        <div className="included-box">
                            <img src={qr} alt='qr' />
                            <p className="sub-heading">QR Code Check-In & Badge Printing</p>
                            <p>Generate unique QR codes for each attendee, scan on arrival, and instantly print professional badges.</p>
                        </div>
                        <div className="included-box">
                            <img src={support} alt='support' />
                            <p className="sub-heading">Support for Live, Hybrid & Online Formats</p>
                            <p>Host your ceremony on-site, online, or both - with attendee tracking and check-in features that adapt to your event format.</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default NewSolutions;